const serverTypesWithHelpDocs = [
	'cloud.vps',
	'cloud.metal',
	'bare.metal',
	'cloud.vps.win',
	'cloud.metal.win',
	'bare.metal.win',
	'pkg-cloud.vps',
	'pkg-cloud.metal',
	'pkg-bare.metal',
	'pkg-cloud.vps.win',
	'pkg-cloud.metal.win',
	'pkg-bare.metal.win',
] as const;

export type ServerTypeWithHelpDocs = (typeof serverTypesWithHelpDocs)[number];

export const isServerTypeWithHelpDocs = (
	serverType: string,
): serverType is ServerTypeWithHelpDocs => {
	return (serverTypesWithHelpDocs as readonly string[]).includes(serverType);
};
